<div class='hvac-iframe-primer' *ngIf="showIframe$ | async">
    <iframe [src]="primerFrameUrl | safe:'resourceUrl'"></iframe>
</div>
